import { Button } from "reactstrap";
import { Container } from './styles/CardOfertas/styled.components';

export const CardOfertas = ({ _this, d, index, imagen }) => {
    return (
        <Container>
            <div className="dv_Vacante max-card" key={index}>
                <div className="Descripcion styles-description">
                    <div>
                        <label className="lbl_bg">{d.puesto}</label>
                        <label className="lbl_sm">
                            {d.fechaPublicacion !== undefined
                                ? d.fechaPublicacion.replace("T", " ").substring(0, 16)
                                : ""}
                        </label>
                    </div>
                    <div>
                        <label className="lbl_sm">{d.estado + ", "}</label>{" "}
                        <label className="lbl_sm">{d.municipio}</label>
                    </div>
                    {
                        d.tipoContratacion && (
                            <div>
                                <label className="lbl_sm">
                                    {"Tipo Contratación: " +
                                        (d.tipoContratacion
                                            ? d.tipoContratacion
                                            : "No mostrado")}
                                </label>
                            </div>
                        )
                    }

                    <br />
                    <div className="dv_Vacante_Btn_Img">
                        <img src={imagen} alt=" " className="Hide_Web styles-image" />
                        <Button
                            color="success"
                            className="btn_verVacante Hide_Web"
                            onClick={e => _this.mostrarOferta(d.puesto, e)}
                            idvacante={d.idSolicitud + "," + d.idZonificacion}
                        >
                            Ver Vacante
                        </Button>
                    </div>
                </div>
                <div className="Imagen Hide_movil">
                    <img src={imagen} alt=" " />
                    <br />
                    <Button
                        color="success"
                        className="btn_verVacante"
                        onClick={e => _this.mostrarOferta(d.puesto, e)}
                        idvacante={d.idSolicitud + "," + d.idZonificacion}
                    >
                        Ver Vacante
                    </Button>
                </div>
            </div>
        </Container>
    )
}
